import { NgModule } from '@angular/core';
import { BaseModule } from '../../shared/base.module';

//ngx-bootstrap modules
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import {AccordionModule} from "ngx-bootstrap/accordion";
import {BsDropdownModule} from "ngx-bootstrap/dropdown";
import {CollapseModule} from "ngx-bootstrap/collapse";
import {PopoverModule} from "ngx-bootstrap/popover";
import {TooltipModule} from "ngx-bootstrap/tooltip";
import {TabsModule} from "ngx-bootstrap/tabs";

import { TinymceModule } from 'angular2-tinymce';
import { ModalModule } from 'ngx-bootstrap/modal';
import { MyDatePickerModule } from 'mydatepicker';
import {
    PERFECT_SCROLLBAR_CONFIG,
    PerfectScrollbarConfigInterface,
    PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import { SharedPopoverModule } from '../../shared/popover/popover.module';
import { MATERIALS } from '../../app.materials';
import { FormsModule } from '@angular/forms';
import { DialogModule } from '../../dialog/dialog.module';
import { B2CAdminRoutesModule } from './b2c-admin.routes';
import { NotificationModule } from '../../shared/notification/notification.module';
import { CouponsModule } from '../../coupons/coupons.module';
import { VouchersModule } from '../../vouchers/vouchers.module';
import { AppointmentsModule } from '../../appointments/appointments.module';
import { HomeService } from '../home.service';
import { MaintenanceComponent } from '../../maintenance/maintenance.component';
import { HighchartsChartModule } from 'highcharts-angular';
import { ImpersonateModule } from './dashboard/impersonate/impersonate.module';
import { B2CAdminDashboardFiltersModule } from './dashboard/filters/b2c-admin-filters.module';
import { EventsModule } from './dashboard/events/events.module';
import { PackageBillingModule } from './dashboard/package-billing/package-billing.module';
import { DynamicReportModule } from './dashboard/dynamic-report/dynamic-report.module';
import { JwtTokenModule } from './dashboard/jwt-token/jwt-token.module';
import { PlatformRegistrationCountsModule } from './dashboard/platform-registration-counts/platform-registration-counts.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
    useBothWheelAxes: true
};

@NgModule({
    imports: [
        MATERIALS,
        FormsModule,
        BaseModule,
        B2CAdminRoutesModule,
        NotificationModule,
        MyDatePickerModule,
        TabsModule.forRoot(),
        DialogModule,
        SharedPopoverModule,
        AccordionModule.forRoot(),
        TypeaheadModule.forRoot(),
        ModalModule.forRoot(),
        CollapseModule.forRoot(),
        BsDropdownModule.forRoot(),
        PopoverModule.forRoot(),
        TinymceModule.withConfig({
            menubar: false,
            elementpath: false,
            toolbar: 'bold italic alignleft numlist bullist link formatselect'
        }),
        TooltipModule.forRoot(),
        PerfectScrollbarModule,
        CouponsModule,
        VouchersModule,
        ImpersonateModule,
        PlatformRegistrationCountsModule,
        PackageBillingModule,
        AppointmentsModule,
        HighchartsChartModule,
        EventsModule,
        B2CAdminDashboardFiltersModule,
        DynamicReportModule,
        JwtTokenModule,
    ],
    declarations: [
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        },
        HomeService,
        MaintenanceComponent
    ]
})

export class B2CAdminModule {
}
